import { TApisOfSchemas } from '../..';
import type ISchemas from './schemas';

const apis: TApisOfSchemas<ISchemas> = {
  getPoint: () => ({
    url: 'pellekan/api/v1/user/point',
    method: 'GET',
  }),
  getFestivalScore: () => ({
    url: 'pellekan/api/v1/user/score',
    method: 'GET',
  }),
  getInviteLink: () => ({
    url: 'Pellekan/api/v1/Campaigns/Invite',
    method: 'GET',
  }),
  requestFetchingRepresentativeUserInfo: (input) => ({
    url: 'Pellekan/anonymous/api/v1/Campaigns/RepresentativeUserInfo',
    method: 'POST',
    data: input,
  }),
  registerFestival: (input) => ({
    url: 'pellekan/api/v1/campaigns/register',
    method: 'POST',
    data: input,
  }),
};

export default apis;
